var r = /* @__PURE__ */ ((l) => (l[l.Small = 0] = "Small", l[l.Large = 1] = "Large", l))(r || {});
export {
  r as LoaderSize
};
//# sourceMappingURL=LoaderSize.js.map
